import { useState } from "react";

const brands = [
  {
    name: "Jo Malone London",
    stripe: "linear-gradient(90deg, #F5EBE0, #E5D5C5)",
    bg: "linear-gradient(135deg, #4A3B31, #241813)",
    text: "#F5EBE0",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/xgnvj7y4_jo-malone-logo-white-transparent.png",
    logoScale: 2,
    photo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/7i06pvoq_jo-malone-northpark.webp",
    desc: "We designed and executed the brand's signature Christmas activations and the Frangipani collection launch. Our visual merchandising strategy included developing precise planograms across 600 locations to ensure strict brand exclusivity and global consistency.",
  },
  {
    name: "MAC Cosmetics",
    stripe: "linear-gradient(90deg, #8B3BCF, #5BD4E0)",
    bg: "linear-gradient(135deg, #241B3D, #0E1226)",
    text: "#F5EBE0",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/xb8mduwh_mac-cosmetics-logo_white_transparent.png",
    photo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/607p8wzo_M%C2%B7A%C2%B7C%20Salt%20Lake%20City%20International%20Store%202.jpg",
    desc: "We spearheaded visual execution for Viva Glam, Skin Finish Studio Radiance, Lip Glaze, Nude Lips, and Dazzle Eyes + Lip launches. Scope included creative direction across all NA locations, Christmas retail campaigns, and the new Bloomingdale's opening in 2025.",
  },
  {
    name: "Prada",
    stripe: "linear-gradient(90deg, #C99FE8, #8B3BCF)",
    bg: "linear-gradient(135deg, #6C3AA6, #3A1E63)",
    text: "#F5EBE0",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/34119noz_prada-logo-png_seeklogo-111420_white_transparent.png",
    photo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/dolsxjoi_Prada.webp",
    desc: "We orchestrated the grand opening at Macy's 34th Street in 2025 and developed comprehensive visual merchandising guidelines for the Bloomingdale's flagship, elevating the brand's luxury footprint and in-store experience.",
  },
  {
    name: "Valentino",
    stripe: "linear-gradient(135deg, #F582A0, #8B3BCF, #5BD4E0)",
    bg: "linear-gradient(135deg, #C81E5B, #6E1D8F)",
    text: "#FFFFFF",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/t8sx0609_valentino-logo-freelogovectors_net__white_transparent.png",
    photo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/znhptuit_Valentino%20.webp",
    desc: "We designed and executed seasonal activations, translating the brand's luxury aesthetic into immersive pop-up experiences for Father's Day and Valentine's Day 2026.",
  },
  {
    name: "Uniqlo",
    stripe: "linear-gradient(90deg, #F582A0, #E63B8E)",
    bg: "linear-gradient(135deg, #E63B8E, #B01E5E)",
    text: "#FFFFFF",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/ffp92d4n_uniqlo-logo_white_transparent.png",
    photo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/371asks2_uniqlo.jpeg",
    desc: "We led the North American visual merchandising strategy for 2023. By forecasting every campaign for the year, we ensured consistency in visual guidelines and budget management across all store locations.",
  },
  {
    name: "Sephora",
    stripe: "linear-gradient(90deg, #F582A0, #8B3BCF)",
    bg: "linear-gradient(135deg, #101326, #2A1746)",
    text: "#F5EBE0",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/5dja1kr0_sephora-logo_white_transparent.png",
    photo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/801o3wcl_sephora.jpeg",
    desc: "Multi-year partnership: custom gondola displays, end caps, and retail campaigns for Estée Lauder, L'Oréal, and Puig brands. Pop-ups and events across NA, including 6 launches for Charlotte Tilbury and 1 for Jo Malone London.",
  },
  {
    name: "Bloomingdale's",
    stripe: "linear-gradient(90deg, #E63B8E, #C99FE8)",
    bg: "linear-gradient(135deg, #B23A82, #7A2E9E)",
    text: "#FFFFFF",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/e5r5j65l_bloomingdales-logo-png-transparent_white_transparent.png",
    logoScale: 2,
    photo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/n4sck72l_Bloomingdales-Give-Happy-Holiday-Windows-Cozy-Comforts.webp",
    desc: "We led the installation and graphic signage for Christmas 2022 across all fashion and cosmetics departments, from promotional displays to elaborate holiday installations that transformed the retail environment.",
  },
  {
    name: "Charlotte Tilbury",
    stripe: "linear-gradient(90deg, #F582A0, #C99FE8)",
    bg: "linear-gradient(135deg, #A82C63, #5E2183)",
    text: "#FFFFFF",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/nwxfyk1k_charlotte-tilbury-logo-freelogovectors_net__white_transparent.png",
    logoScale: 2,
    photo: `${process.env.PUBLIC_URL}/img/charlotte-tilbury.jpg`,
    desc: "In collaboration with Sephora, we executed comprehensive visual takeovers for the premium skincare line and the Pillow Talk collection, including design, management, and rollout of immersive pop-up experiences.",
  },
  {
    name: "American Museum of Natural History",
    stripe: "linear-gradient(90deg, #A5E8F0, #5BD4E0)",
    bg: "linear-gradient(135deg, #12505E, #0C2A38)",
    text: "#EAF9FC",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/wuo0j08x_6945582-logo_white_transparent.png",
    logoScale: 2,
    photo: `${process.env.PUBLIC_URL}/img/amnh.jpg`,
    desc: "We partnered on the traveling T. rex exhibition (toured and sold to numerous museums), design for the Oceans exhibition, and architectural renderings for the museum's new science center.",
  },
];

export const BrandPortfolio = () => {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="brand-portfolio">
      <div className="bp-grid">
        {brands.map((b, i) => (
          <div
            key={i}
            className={`bp-card ${active === i ? "active" : ""}`}
            data-testid={`brand-card-${i + 1}`}
            onClick={() => setActive((prev) => (prev === i ? null : i))}
          >
            <div className="bp-reveal" style={{ background: b.bg, color: b.text }}>
              <div className="bp-reveal-overlay" />
              <div className="bp-reveal-top">
                {b.logo ? (
                  <span className="bp-logo-chip">
                    <img
                      src={b.logo}
                      alt={`${b.name} logo`}
                      style={{ transform: `scale(${b.logoScale || 2})`, transformOrigin: "left center" }}
                    />
                  </span>
                ) : (
                  <div className="bp-reveal-name" style={{ color: b.text }}>{b.name}</div>
                )}
              </div>
              <p className="bp-reveal-desc" style={{ color: b.text }}>{b.desc}</p>
            </div>
            <div className="bp-default">
              {b.photo ? (
                <img src={b.photo} alt={b.name} className="bp-default-img" loading="lazy" />
              ) : (
                <span className="bp-name-default">{b.name}</span>
              )}
            </div>
            <div className="bp-stripe" style={{ background: b.stripe }} />
          </div>
        ))}
      </div>
      <p className="bp-note">Logos and full case details to be added.</p>
    </div>
  );
};
